import { render } from "./MasterOrder.vue?vue&type=template&id=3637a401&scoped=true"
import script from "./MasterOrder.vue?vue&type=script&lang=js"
export * from "./MasterOrder.vue?vue&type=script&lang=js"

import "./MasterOrder.vue?vue&type=style&index=0&id=3637a401&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3637a401"]])

export default __exports__